<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">忘れず注文商品対象選択</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <!-- ダイアログ表示コンテンツメイン -->
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="block-row">
          <button
            id="btn_SearchGoods" 
            class="btn-secondary"
            [tabindex]="0"
            (click)="eventSearchGoods_CLICKHandler()"
          >
            商品検索
          </button>
        </div>

        <div>
          <div>
            <!-- データグリッド定義 eBASE 取込商品候補一覧 -->
            <wj-flex-grid
              #dtg_GoodsList
              id="dtg_GoodsList"
              [itemsSource]="model.candidateGoodsList"
              [tabindex]="0"
              [frozenColumns]="2"
              [selectionMode]="'Row'"
              [headersVisibility]="'Column'"
              [isReadOnly]="false"
              [allowDragging]="'None'"
              [allowSorting]="false"
            >
              <wj-flex-grid-column [minWidth]="5" [width]="40" [header]="' '" [binding]="'selected'" [align]="'center'" [dataMap]="dataMap" [dataMapEditor]="dataMapEditor"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="100" [isReadOnly]="true" [header]="'アイテムコード'" [binding]="'itemCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="90" [isReadOnly]="true" [header]="'Ｐコード'" [binding]="'pCode'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="160" [isReadOnly]="true" [header]="'部門'" [binding]="'classCode'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{ cell.item.classCode }}:{{ cell.item.className }}
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="200" [isReadOnly]="true" [header]="'バイヤーコード'" [binding]="'buyerCode'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{ cell.item.buyerCode }}:{{ cell.item.buyerName }}
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="295" [isReadOnly]="true" [header]="'商品名'" [binding]="'guideGoodsName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="200" [isReadOnly]="true" [header]="'規格名'" [binding]="'guideStandardName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="200" [isReadOnly]="true" [header]="'メーカー名'" [binding]="'makerName'"></wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="237" [isReadOnly]="true" [header]="'支払先取引先'" [binding]="'payeeClientCode'">
                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                  {{ cell.item.payeeClientCode }}:{{ cell.item.payeeClientKanji }}
                </ng-template>
              </wj-flex-grid-column>
              <wj-flex-grid-column [minWidth]="5" [width]="130" [isReadOnly]="true" [header]="'本登録日時'" [binding]="'regularRegistDate'"></wj-flex-grid-column>
            </wj-flex-grid>
          </div>
        </div>
      
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button forcedEnabledMode="true" class="btn-primary" [tabindex]="0" (click)="eventSelect_CLICKHandler()">
            登録商品として使用
          </button>
        </div>

        <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
        <div class="window-title-close">
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
